import React from 'react'
import { Row, Col } from "reactstrap";
import Dropdown from '../../components/Dropdown';
import History_illness_Chart from './demoChart/History_illness_Chart'

export default function History_illness() {
  return (
    <Row>
            <div className="box-graph-total">
          <br />
          <Row>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <p className="text-header-total-dashboard-sm-graph-by-nile">
              History illness
              </p>
              <Dropdown
                items={["ม.ค.", "ก.พ.", "มี.ค." , "เม.ย." , "พ.ค." , "มิ.ย." , "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.","พ.ย.","ธ.ค." ]}
                // styles={{ marginBottom : "50px" }}
                itemCallback={(item) => {}}
              />
              <br />
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <p className="text-header-total-dashboard-lg-graph-by-nile">
              History illness
              </p>
            </Col>
            <Col xs={0} sm={0} md={4} lg={4} xl={4} />
          </Row>
          <Row>
            <Col >
            <History_illness_Chart />
            </Col>
          </Row>
          <br />
        </div>
      </Row>
  )
}